// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import('/tol/jenkins/workspace/changbai-app-admin-merchant/src/.umi-production/umi.ts')
export default 1
